

















































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import ColorPicker from '@/components/ColorPicker.vue'
import { colord } from 'colord'
import type { Color, UIColor } from '@/interfaces'

@Component({
  components: {
    ColorPicker,
    PageHead,
  },
})
export default class ColorSchemePage extends Vue {
  pageTitle = 'Colour Scheme Editor'
  callInProgress = false
  colors: UIColor[] = null
  colorsMap: UIColor[] = [
    { name: 'text', hex: '#242424', hidden: false, initShowPicker: false, hint: '<h2>Text Colour</h2><p>This is the colour of your main text contents, and the text in the sidebar.</p>', highlightElement: false },
    { name: 'link', hex: '#2F69B9', hidden: false, initShowPicker: false, hint: '<h2>Linknotes / Accent Colour</h2><p>This is the colour of your linknotes - Clickable links look like this. The colour is also used for Quote Boxes and the Call and Email action buttons. Think of it as an accent colour.</p>', highlightElement: false },
    { name: 'subheading', hex: '#6A9764', hidden: false, initShowPicker: false, hint: '<h2>Sub Headings Colour</h2><p>This is the colour of all subheadings in your main content area.</p>', highlightElement: false },
    { name: 'background', hex: '#4F7264', hidden: false, initShowPicker: false, hint: '<h2>Background Colour</h2><p>The colour of the heading area at the top of the page and the bar at the bottom. It is also the background colour to sidebar headings. The background to the whole website is a pale version of this colour.</p>', highlightElement: false },
    { name: 'menutext', hex: '#ffffff', hidden: false, initShowPicker: false, hint: '<h2>Menu Text Colour</h2><p>This is the colour of menu text, apart from the text for the current page which is fixed as white.</p>', highlightElement: false },
    { name: 'menubackground', hex: '#43887B', hidden: false, initShowPicker: false, hint: '<h2>Menu Background Colour</h2><p>This is the background colour of the active item in the menu, in other words the page currently showing.</p>', highlightElement: false },
    { name: 'em', hex: '#D63C3C', hidden: false, initShowPicker: false, hint: '<h2>Emphasised Text Colour</h2><p>This is the colour of text which has been emphasised using the &lt;EM&gt; code.</p>', highlightElement: false },
    { name: 'backgroundpale08', hex: '#ffffff', hidden: true, initShowPicker: false, hint: '', highlightElement: false },
    { name: 'backgroundpale06', hex: '#f9fafa', hidden: true, initShowPicker: false, hint: '', highlightElement: false },
    { name: 'backgroundpale04', hex: '#bcd1c9', hidden: true, initShowPicker: false, hint: '', highlightElement: false },
  ]

  scheme: Color[] = null

  infoText = 'Click on boxes below to select and change colors of respective highlighted elements in the preview pane.'
  cssArgs = null
  topLogo = null
  // heroImage = 'http://localhost/images/076DB2BC-6EA2-4B2E-B55D-EA3DB8C7D3D8.jpg'
  heroImage = null
  heroImageUrl = null
  template = null
  urlScheme = window.location.protocol

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchDomainColorScheme()
  }

  public async fetchDomainColorScheme() {
    this.callInProgress = true
    try {
      const domainColorResponse = await Api.getDomainColorScheme()
      this.scheme = domainColorResponse.scheme
      this.cssArgs = domainColorResponse.cssArgs
      this.topLogo = domainColorResponse.top_logo
      this.heroImage = domainColorResponse.heroImage
      this.template = domainColorResponse.template
      this.xcss = domainColorResponse.xcss
      this.css = domainColorResponse.css
      this.heroImageUrl = this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + domainColorResponse.heroImage
      this.headBg = this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + domainColorResponse.headBg
      this.footBg = this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + domainColorResponse.footBg
      this.bodyBg = this.urlScheme + '//' + Helper.getCurrentDomain() + '/images/' + domainColorResponse.bodyBg
      this.mapSchemeToColors()
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async setDomainColorScheme() {
    this.callInProgress = true
    try {
      this.scheme = await Api.setDomainColorScheme(this.colors)
      // this.mapSchemeToColors()
      this.callInProgress = false
      Notify.create({
        type: 'success',
        title: 'Saved!',
        text: 'Colour Scheme Saved.',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public getColors(): UIColor[] {
    const colors = []
    for (const color of this.colors) {
      if (!color.hidden) {
        colors.push(color)
      }
    }
    return colors
  }

  private mapSchemeToColors() {
    const localColors = []
    for (const mapColor of this.colorsMap) {
      let colorMapped = false
      for (const schemeColor of this.scheme) {
        if (schemeColor.name === mapColor.name) {
          const color = mapColor
          color.hex = schemeColor.hex
          localColors.push(color)
          colorMapped = true
        }
      }
      if (!colorMapped) {
        const color = mapColor
        localColors.push(color)
      }
    }
    this.colors = localColors
  }

  public hideColorPickers(excludeColorName) {
    for (const color of this.colors) {
      if (color.name !== excludeColorName) {
        color.initShowPicker = false
        color.highlightElement = false
      } else {
        color.highlightElement = true
      }
    }
    // this.updateHiddenColors()
  }

  public updateColor(colorName, colorHex, showPicker) {
    for (const color of this.colors) {
      if (color.name === colorName) {
        color.hex = colorHex
        color.initShowPicker = showPicker
      }
    }
    this.updateHiddenColors()
    this.$forceUpdate()
  }

  private updateHiddenColors() {
    for (const color of this.colors) {
      if (color.name === 'backgroundpale08') {
        color.hex = colord(this.getColor('background')).lighten(0.4).toHex()
      }
      if (color.name === 'backgroundpale06') {
        color.hex = colord(this.getColor('background')).lighten(0.6).toHex()
      }
      if (color.name === 'backgroundpale04') {
        color.hex = colord(this.getColor('background')).lighten(0.4).toHex()
      }
    }
  }

  public getColor(colorName) {
    for (const color of this.colors) {
      if (color.name === colorName) {
        return color.hex
      }
    }
    return null
  }

  public getBorder(colorName) {
    for (const color of this.colors) {
      if (color.name === colorName) {
        return color.highlightElement ? '3px solid rgba(255,000,000,1)' : '3px solid rgba(255,000,000,0)'
      }
    }
    return null
  }
}

